export const getWeeklyEvaluationData = (
  stores: any[],
  getWeekEvaluationsWithData: (storeNumber: number) => any[]
) => {
  const counts = {
    threeComplete: 0,
    twoComplete: 0,
    oneComplete: 0,
    zeroComplete: 0
  };

  const storesByCount = {
    threeComplete: [] as any[],
    twoComplete: [] as any[],
    oneComplete: [] as any[],
    zeroComplete: [] as any[]
  };

  stores.forEach(store => {
    const weekEvals = getWeekEvaluationsWithData(store["Store Number"]);
    // Look at the first week (current week) evaluations
    const currentWeekEvals = weekEvals[0]?.evaluations || [];
    const completedCount = currentWeekEvals.filter((evaluation: any) => 
      evaluation.title !== 'N/A' && evaluation.score !== 'N/A' && evaluation.date !== 'N/A'
    ).length;
    
    if (completedCount === 3) {
      counts.threeComplete++;
      storesByCount.threeComplete.push(store);
    } else if (completedCount === 2) {
      counts.twoComplete++;
      storesByCount.twoComplete.push(store);
    } else if (completedCount === 1) {
      counts.oneComplete++;
      storesByCount.oneComplete.push(store);
    } else {
      counts.zeroComplete++;
      storesByCount.zeroComplete.push(store);
    }
  });

  return { counts, storesByCount };
};

export const getStoresByEvaluationCount = (
  stores: any[],
  getWeekEvaluationsWithData: (storeNumber: number) => any[],
  targetCount: number
) => {
  const { storesByCount } = getWeeklyEvaluationData(stores, getWeekEvaluationsWithData);
  
  let targetStores;
  if (targetCount === 3) targetStores = storesByCount.threeComplete;
  else if (targetCount === 2) targetStores = storesByCount.twoComplete;
  else if (targetCount === 1) targetStores = storesByCount.oneComplete;
  else targetStores = storesByCount.zeroComplete;
  
  // Enhance stores with evaluation dates for display
  return targetStores.map(store => {
    const weekEvals = getWeekEvaluationsWithData(store["Store Number"]);
    const currentWeekEvals = weekEvals[0]?.evaluations || [];
    const completedEvals = currentWeekEvals.filter((evaluation: any) => 
      evaluation.title !== 'N/A' && evaluation.score !== 'N/A' && evaluation.date !== 'N/A'
    );
    
    const evaluationDates = completedEvals.map((evaluation: any) => evaluation.date).join(', ');
    
    return {
      ...store,
      evaluationDates: evaluationDates || 'No evaluations completed'
    };
  });
};